import React from 'react';
import { Navigate } from 'react-router-dom';

export default function LoginExitoso() {
  return <Navigate to="/" replace />;
}
